import React, { useState } from 'react'
import styled from 'styled-components'
import { Segment } from '../Segment'
import { Separator } from '../Separator'

const TabsContainer = styled.div`
  display: flex;
  margin-bottom: 20px;
`

const Container = styled.div`
  margin-top: 24px;
  max-height: 543px;
  overflow-y: auto;
`

export interface ModalTabsProps {
  steps: {
    title: string
    content: React.ReactNode
  }[]
}

export const ModalTabs = ({ steps }: ModalTabsProps) => {
  const [currentStep, setCurrentStep] = useState(0)

  return (
    <>
      <TabsContainer>
        {steps.map(({ title }, index) => (
          <div key={title + index} onClick={() => setCurrentStep(index)}>
            <Segment type="text" label={title} active={currentStep === index} />
          </div>
        ))}
      </TabsContainer>
      <Separator />
      <Container>{steps[currentStep].content}</Container>
    </>
  )
}
